import _ from "lodash";
import { getThumbBaseUrl } from "store/static";

export const getRethumbUrl = ({
  width,
  height,
  imageUrl,
  widthScaleFactor = 1,
  heightScaleFactor = 1,
  fitIn = false,
}) => {
  // Handling spaces
  const replacedUrl = _.replace(imageUrl, /\s/g, "%20");

  if (!replacedUrl) {
    return "";
  }
  const finalWidth = Math.round(widthScaleFactor * width);
  const finalHeight = Math.round(heightScaleFactor * height);
  if (fitIn) {
    return `${getThumbBaseUrl()}fit-in/${finalWidth}x${finalHeight}/${replacedUrl}`;
  } else {
    return `${getThumbBaseUrl()}${finalWidth}x${finalHeight}/${replacedUrl}`;
  }
};
